module.exports = __webpack_public_path__ + "packs/media/images/check-b9575d8c0145983a9f4e6015c5a7490d.png";